<template>
  <div class="login">
    <div class="holder">
      <img src="../assets/imgs/logo-petit-nature.jpg" alt="" />
      <login-form></login-form>
    </div>
  </div>
</template>

<script>
import LoginForm from "../components/LoginForm";
export default {
  name: "login",
  components: { LoginForm }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #fff;
  .title {
    color: $primary;
  }
  .holder {
    border: 1px solid $grey;
    padding: 25px;
    width: 350px;
  }
}
</style>
